import compose from 'recompose/compose';
import mapProps from 'recompose/mapProps';
import List from '../../components/admin/collections/list/index';
import withUpdateActionTime from './with-action-time';

const enhance = compose(
	withUpdateActionTime,
	mapProps(({history}) => ({history}))
);

export default enhance(List);



// WEBPACK FOOTER //
// ./src/client/pages/admin/collection-list.jsx